import { cn } from "@/utils/classes";
import { ReactNode } from "react";

/* Prop Types */
interface BadgeProps {
  className?: string;
  children: ReactNode;
}

/*
 * Badge Component
 */
export const Badge = ({ children, className }: BadgeProps) => {
  return <span className={cn("badge h-auto gap-2 rounded-lg p-2", className)}>{children}</span>;
};
